import React, { FC, useContext } from 'react';
import { FormattedMessage } from 'react-intl';
import styled from 'styled-components';

import { GICheckbox, GIFormControl, GIFormLabel } from '@components/common/app-components/GIInput';
import { ConditionalRendering } from '@components/common/conditional-rendering';
import { RELATIONSHIP_TYPES } from '@constants/common/relationShipTypes';
import { TXN_REASON, TXN_TYPES, TXN_TYPES_OPTIONS } from '@constants/enrollmentList/enrollmentList.constant';
import { INPUT_TYPES } from '@constants/inputs/inputTypes';
import Dropdown from '@lib/inputs/Dropdown';
import { changeFieldValue } from '../common/enrollmentUtils';
import { IEnrollee } from '../common/types';
import { AddOrChangeTxnFormContext } from '../context/AddOrChangeTxnProvider';
import { EnrollmentContext } from '../context/MemberMyEnrollmentProvider';

const StyledField = styled.div`
    width: 50px;
    display: flex;
    justify-content: center;
    align-items: center;
    .gi-checkbox__label {
        margin: 0;
    }
`;

interface EnrollmentTxnTypeRendererProps {
    enrollee: IEnrollee;
}

const EnrollmentTxnTypeRenderer: FC<EnrollmentTxnTypeRendererProps> = ({ enrollee }) => {
    const { isEdit } = useContext(EnrollmentContext);
    const { watch, setValue } = useContext(AddOrChangeTxnFormContext);
    const values = watch();

    const handleChange = (value: string) => {
        const enrolleeDataDtoList = values.enrolleeDataDtoList.map((enrolleeDetails, index) => {
            if (index === enrollee.index) {
                if (value === TXN_TYPES.Add) {
                    enrolleeDetails.txnReason = TXN_REASON.EC;
                } else if (value === TXN_TYPES.Change) {
                    enrolleeDetails.txnReason = TXN_REASON.TwentyNine;
                } else {
                    enrolleeDetails.txnReason = TXN_REASON.AI;
                }
                enrolleeDetails.txnType = value;
                return enrolleeDetails;
            }
            return enrolleeDetails;
        });
        changeFieldValue(setValue, 'enrolleeDataDtoList', enrolleeDataDtoList);
    };

    const handleCheckBoxClick = (event: React.ChangeEvent<HTMLInputElement>) => {
        changeFieldValue(setValue, `enrolleeDataDtoList.${enrollee.index}.txnType`, event.target.checked);
    };

    return (
        <>
            <ConditionalRendering isTrue={!isEdit}>
                <StyledField>
                    <GIFormControl
                        id={`txnType-form-${enrollee.firstName}`}
                        name={`txnType-${enrollee.firstName}`}
                        type="checkbox"
                    >
                        <GICheckbox
                            id={`txnType-${enrollee.firstName}`}
                            name={`txnType-${enrollee.firstName}`}
                            value={enrollee.txnType}
                            checked={!!enrollee.txnType}
                            disabled={enrollee.relationshipToSubscriber.toUpperCase() === RELATIONSHIP_TYPES.SELF.value}
                            onChange={handleCheckBoxClick}
                        />
                        <GIFormLabel id={`txnType-${enrollee.firstName}`} name={`txnType-${enrollee.firstName}`}>
                            <FormattedMessage id="common.no_text" />
                        </GIFormLabel>
                    </GIFormControl>
                </StyledField>
            </ConditionalRendering>
            <ConditionalRendering isTrue={isEdit}>
                <Dropdown
                    label={{
                        text: '',
                        labelClass: [''],
                    }}
                    inputData={{
                        inputClasses: [''],
                        options: TXN_TYPES_OPTIONS,
                        type: INPUT_TYPES.DROPDOWN,
                        value: enrollee.txnType,
                        isInputRequired: false,
                        disabled: enrollee.relationshipToSubscriber.toUpperCase() === RELATIONSHIP_TYPES.SELF.value,
                    }}
                    inputActions={{
                        handleFieldChange: handleChange,
                    }}
                />
            </ConditionalRendering>
        </>
    );
};

export default EnrollmentTxnTypeRenderer;
